module.exports = __webpack_public_path__ + "img/bg-bg-new-main-top-pc.362e7064.svg";